import classnames from 'classnames/bind';
import style from './header.module.scss';
import CloseButton from '@common/closeButton';
import React from 'react';

interface LastModalHeaderProps {
  questionCount: number;

  onCloseClick: () => void;
}

const cx = classnames.bind(style);

const InterviewPracticeQuestionSelectLastModalHeader = (props: LastModalHeaderProps) => {
  const { questionCount } = props;
  const durationTime = questionCount * 2;

  return (
    <div className={cx('headerWrap')}>
      <div className={cx('header')}>
        <div className={cx('titleWrap')}>
          <div className={cx('title')}>연습 준비 마지막 단계입니다.</div>
          <div className={cx('description')}>마지막으로 질문순서와 예상시간을 확인해 주세요.</div>
        </div>
        <div className={cx('stateWrap')}>
          <div className={cx('part')}>
            <div className={cx('num')}>{`${durationTime}분`}</div>
            <div className={cx('desc')}>예상 시간</div>
          </div>
          <div className={cx('part')}>
            <div className={cx('num')}>{`${questionCount}개`}</div>
            <div className={cx('desc')}>질문 개수</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewPracticeQuestionSelectLastModalHeader;
